export const ELEMENTS = {
	firstLevelListItems: () => document.querySelectorAll('header.nav li.lvl--1:has(ul)'),
	firstLevelSubmenuListItems: () => document.querySelectorAll('header.nav nav.left li.lvl--1:has(nav.sub--menu)'),
	levelTriggerButtons: () => document.querySelectorAll('header.nav button:has(+ ul)'),
	nav: () => document.querySelector('header.nav'),
	navContainer: () => document.querySelector('header.nav .container'),
	openLevelListItem: () => document.querySelector('header.nav li.lvl--1.lvl--open:has(> ul)'),
	openSubMenuListItem: () => document.querySelector('header.nav li.lvl--1.lvl--open:has(> nav)'),
	searchListItem: () => document.querySelector('header.nav li.lvl--search'),
	subMenuTriggerButtons: () => document.querySelectorAll('header.nav button:has(+ nav)'),
};

export const CLASSNAMES = {
	levelOpen: 'lvl--open',
	firstLevel: 'lvl--1',
	navBg: 'nav--bg',
	navOnHighlight: 'nav--on-highlight',
};

export const DESKTOP_BREAKPOINT = 1200;
